import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

// slices
import storeReducer from "./storeSlice";
import adminReducer from "./adminSlice";
import ownerReducer from "./ownerSlice";
import storeFormSlice from "./storeFormSlice";
import customerSlice from "./customerSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["store", "admin", "owner", "customer"], // ✅ add here if you want persistence
};

const rootReducer = combineReducers({
  store: storeReducer,
  admin: adminReducer,
  owner: ownerReducer,
  customer: customerSlice,
  storeForm: storeFormSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
